import type { HeroProps } from '@/components/PolicyTwo/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/PolicyTwo/policyTwo__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout, showAskUsAnything: true },
  seo: {
    ...sharedConfig['nl-NL'].seo,
    title: 'Polis 2.0 van Lemonade verzekering | Lemonade',
    description:
      "Dit is Polis 2.0 van Lemonade: een radicaal vereenvoudigde, gemoderniseerde en gedigitaliseerde verzekeringspolis. Ons doel is om verzekeringen te transformeren van een noodzakelijk kwaad naar een maatschappelijk belang en we willen graag dat iedereen bijdraagt en profiteert van 's werelds eerste open-source verzekeringspolis.",
    ogImage: og.src,
  },
  hero: {
    title: "'s Werelds eerste\nopen-source verzekeringspolis",
    subtitle:
      'Polis 2.0 is een radicaal vereenvoudigde, gemoderniseerde en gedigitaliseerde verzekeringspolis. Dit betekent dat je het daadwerkelijk kunt lezen en begrijpen!',
    ctaLabel: 'lees de polis',
  },
  MDXContent: content as DocumentTypes,
};
